import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useAuthState } from "../../context/context"
import { useHistory, Link } from "react-router-dom/cjs/react-router-dom.min"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"

export const UpgradeSubscriptionDialog = (props) => {

    const { t } = useTranslation()
    const currentUser = useAuthState()
    const history = useHistory();
    
    return (
        <div className={props.className}>
            <Dialog header={t('entreprise.upgrade_to_preminum')} visible={props.dialogVisible} style={{ width: '30vw' }} onHide={() => props.setDialogVisible(false)}>
                <div className="dip-ta-center">
                    <p>{t('entreprise.feature_required_premium')}</p>
                    <Link to={{ pathname: '/profile_company', hash: "#abonnement" }}>
                        <Button label={t('entreprise.discover_our_offer')} className="dip-btn-iris-bg p-button-rounded" />
                    </Link>
                </div>
            </Dialog>
        </div>
    )
}